import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';

import { User } from '../models';
import { AccountService } from '../services';
import { NotificacionService } from '../services/notificacion.service';
import { MessageService } from 'primeng/api';
import { Vwnotificacion } from '../models/vwnotificacion';

@Component({ templateUrl: 'notificacion-list.component.html' })
export class NotificacionListComponent implements OnInit {
    lstNotificaciones: Vwnotificacion[];
    isLoading: boolean = false;

    activa: Activo = { nombre: "Activo", valor: 1 };
    valoresActivos: Activo[] = [{ nombre: "Activo", valor: 1 }, { nombre: "Inactivo", valor: 0 }, { nombre: "Ambos", valor: null }]

    fechafin: any = null;
    fechaini: any = null;

    constructor(
        private notificacionService: NotificacionService,
        private accountService: AccountService,
        private messageService: MessageService,
    ) { }

    ngOnInit() {
        const currentUser: User = this.accountService.userValue;
        this.buscar();
    }

    buscar() {
        this.lstNotificaciones = []
        this.isLoading = true;

        this.notificacionService.getNotificacions(this.activa?.valor, this.fechaini, this.fechafin)
            .pipe(first())
            .subscribe(lst => {
                this.lstNotificaciones = lst;
                this.isLoading = false;
            });
    }

    marcarRevisada(noti: Vwnotificacion) {
        noti.activa = 0;
        this.notificacionService.updateNotificacion(noti)
            .subscribe();

    }

    cambiarfechaini() {

        if (this.fechaini == null || this.fechafin == null) {
            return;
        }
        if (this.fechaini <= this.fechafin) {
        } else {

            this.messageService.add({
                severity: 'info', summary: 'Aviso',
                detail: 'Información: fecha inicio debe ser menor a la fecha fin'
            });
        }

    }
    cambiarfechafin() {
        if (this.fechaini == null || this.fechafin == null) {
            return;
        }

        if (this.fechafin >= this.fechaini) {

        } else {

            this.messageService.add({
                severity: 'info', summary: 'Aviso',
                detail: 'Información: fecha fin debe ser \nsuperior a la fecha inicio'
            });

        }

    }

}

interface Activo {
    nombre: string;
    valor: any;
}